export const cleanInternalStack = (stack: string): string => stack.replace(/\s+at .*aggregate-error\/index.js:\d+:\d+\)?/g, '');

